import { Button, Loading, Title } from "@components";

import styles from "styles/pages/reports/reports.module.scss";
import CreativesInPeriod from "./CreativesInPeriod";
import ReportFilters from "../ReportFilters";
import { useEffect, useRef, useState } from "react";
import Filters from "../Filters";
import { ReportsAPI } from "providers/ReportsAPI";
import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Currency } from "shared/utils/Currency";
import { If } from "shared/components/control-statements";
import { Numbers } from "shared/utils/Numbers";

const quantities = (data) => {
  return [
    {
      title: "Quantidade de disparos",
      value: Numbers.formatInt(data.sends),
    },
    {
      title: "Quantidade de entregas",
      value: "Em breve",
    },
    {
      title: "Quantidade de aberturas",
      value: Numbers.formatInt(data.opens),
    },
    {
      title: "Quantidade de cliques",
      value: Numbers.formatInt(data.clicks),
    },
  ];
};

const BigNumber = ({ data }) => {
  return (
    <div className={styles.bigNumber}>
      <div className="d-flex flex-column">
        <div className="d-flex align-center">
          <p className={styles.number}>
            {Currency.formatCurrency(data?.send_cost)}
          </p>
        </div>
        <div className={styles.title}>
          <p>Custo com disparos</p>
          <span
            className={styles.info}
            title="Valor total gasto com mensageria."
          >
            <i className="fal fa-info-circle" />
          </span>
        </div>
      </div>
    </div>
  );
};

const CampaignIndicator = ({ data }) => {
  return (
    <div className={styles.campaignIndicator}>
      <div className={styles.value}>{data.value}</div>
      <p className={styles.title}>{data.title}</p>
    </div>
  );
};

export default function Index() {
  const [openFilters, setOpenFilters] = useState(false);
  const [filters, setFilters] = useState({});
  const [dateFilters, setDateFilters] = useState({});
  const [data, setData] = useState({
    period: [],
    keynumbers: {},
  });
  const [loading, setLoading] = useState(true);
  const [label_dict, setLabelDict] = useState(new Map());

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get("campanha");

  const filtersRef = useRef(null);

  const fetchData = async () => {
    setLoading(true);
    const provider = new ReportsAPI();
    const response = await provider.flowCreative(campaignId, id, filters);
    setData(response);
    setLoading(false);
  };

  useEffect(() => {
    fetchUnits();
    fetchData();
  }, [filters]);

  const fetchUnits = async () => {
    const response_units = await OlgaEnvironmentsAPI.getUnits();
    const response_brands = await OlgaEnvironmentsAPI.getBrands();

    const units = response_units.getData([]);
    const brands = response_brands.getData([]);

    setLabelDict(
      new Map([
        ...units.map((unit) => [`units_${unit.id}`, unit.name]),
        ...brands.map((brand) => [`brands_${brand.id}`, brand.name]),
      ])
    );
  };

  return (
    <>
      <Title
        title={`Criativo: ${data.name || ""}`}
        backTo={{
          url: "/relatorios/marketing/campanhas",
          name: "Relatórios de campanhas",
        }}
      >
        <Filters
          onRemoveFilter={(filter) => {
            filtersRef.current?.removeFilter(filter);
          }}
          filters={filters}
          units={label_dict}
        />
        <Button onClick={() => setOpenFilters(true)}>Filtrar</Button>
      </Title>

      <If cond={loading}>
        <Loading fullContent />
      </If>

      <div className={styles.bigNumbersCreatives}>
        <BigNumber data={data.keynumbers} />
        {quantities(data.keynumbers || {}).map((item) => (
          <CampaignIndicator key={item.title} data={item} />
        ))}
      </div>

      <CreativesInPeriod data={data.period} />

      <div className={styles.selectedCampaign}>
        <span className={styles.id}>ID {id}</span>
        <p className={styles.name}>Criativo: {data.name}</p>
      </div>

      <ReportFilters
        ref={filtersRef}
        open={openFilters}
        dateFiltersProp={dateFilters}
        onClose={() => setOpenFilters(false)}
        onUpdateFilters={(filters) => {
          setFilters(filters);
        }}
        hideBrands
        hideOrigins
        onUpdateDateFilters={(filters) => {
          setDateFilters(filters);
        }}
      />
    </>
  );
}
